// @ts-strict-ignore
import {ParamComponent} from 'panel';
import moment from 'moment';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {IronContextRegistry} from 'common/report/context-registry';

import {template} from './template';
import css from './index.inline.styl';

export interface LastUpdatedParams {
  isCompact?: boolean;
  lastRefreshDate?: string;
  refreshIntervalMs?: number;
}

export class LastUpdated extends ParamComponent<LastUpdatedParams, EmptyObj, IronContextRegistry> {
  private _starter = null;
  private _timer = null;
  private _renderTimer = null;

  get config() {
    return {
      defaultParams: {
        lastRefreshDate: new Date().toISOString(),
        refreshIntervalMs: null,
      },

      params: {
        isCompact: Boolean,

        lastRefreshDate: {
          type: String,
        },

        refreshIntervalMs: {
          type: Number,
        },
      },

      css,
      template,
      useShadowDom: true,
      contexts: [`i18n` as const],

      helpers: {
        getLastRefreshRelativeFormat: () =>
          this.params.lastRefreshDate ? this.getContext(`i18n`).timeFromNow(moment(this.params.lastRefreshDate)) : ``,
      },
    };
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);
    switch (attr) {
      case `last-refresh-date`:
        this.updateInterval();
        this.update();
        break;
      case `refresh-interval-ms`:
        this.updateInterval();
        break;
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.updateInterval();
    this._renderTimer = setInterval(() => this.update(), 30 * 1000);
  }

  disconnectedCallback() {
    clearTimeout(this._starter);
    clearInterval(this._timer);
    clearInterval(this._renderTimer);
    super.disconnectedCallback();
  }

  dispatchRefresh() {
    this.dispatchEvent(new CustomEvent(`refresh`));
  }

  updateInterval() {
    clearTimeout(this._starter);
    clearInterval(this._timer);
    const refreshInterval = this.params.refreshIntervalMs;

    if (refreshInterval) {
      const lastRefreshed = moment(this.params.lastRefreshDate);
      const nextRefreshMs = refreshInterval - moment().diff(lastRefreshed, `milliseconds`);
      this._starter = setTimeout(() => {
        this.dispatchRefresh();
        this._timer = setInterval(() => this.dispatchRefresh(), refreshInterval);
      }, nextRefreshMs);
    }
  }
}

export const LastUpdatedEl = defineAndMakeJsxFactory<{params: LastUpdatedParams}>(`mp-last-updated`, LastUpdated);
export const LastUpdatedReact = panel2react<{params: LastUpdatedParams}>(`mp-last-updated`, LastUpdated);
